import { render, staticRenderFns } from "./IconDataTableHeader.vue?vue&type=template&id=39de1390&scoped=true&"
import script from "./IconDataTableHeader.vue?vue&type=script&lang=js&"
export * from "./IconDataTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39de1390",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39de1390')) {
      api.createRecord('39de1390', component.options)
    } else {
      api.reload('39de1390', component.options)
    }
    module.hot.accept("./IconDataTableHeader.vue?vue&type=template&id=39de1390&scoped=true&", function () {
      api.rerender('39de1390', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/IconDataTableHeader.vue"
export default component.exports